export const dwellingTooltip = {
  '5+ hours': 'Percentage of visitors dwelling for 5+ hrs',
  '2-5 hours': 'Percentage of visitors dwelling for 2-5 hrs',
  '1-2 hours': 'Percentage of visitors dwelling for 1-2 hrs',
  '20-60 minutes': 'Percentage of visitors dwelling for 20-60 mins',
  '5-20 minutes': 'Percentage of visitors dwelling for 5-20 mins',
}

export const loyaltyTooltip = {
  Monthly: 'Seen 8 times in the last month',
  Weekly: 'Seen 3 times in the last month',
  Daily: 'Seen 4 times in the last week',
  'First Time': 'Fist time visitor',
}
